import { ConsolidatedLocationView, EventPersonDto, EventVehicleDto } from '@mark43/cad-api';
import { observer } from 'mobx-react';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { useApplicationType } from '../../../common/hooks/use-application-type';
import { RelatedDataTabCommonContent } from './related-data-tab-common-content';

export const RelatedDataTabContent = observer(function RelatedDataTabContent(props: {
    phoneNumbers: string[];
    reportingParties: EventPersonDto[];
    vehicles: EventVehicleDto[];
    location?: ConsolidatedLocationView;
    onViewMoreCadEvents: () => void;
    onViewMoreRmsReports: () => void;
    onViewMoreVehicles: () => void;
}) {
    const { isFirstResponder } = useApplicationType();

    if (isFirstResponder) {
        return <RelatedDataTabCommonContent {...props} />;
    }

    return (
        <EventPanelTab title="Related Data">
            <TabBody>
                <RelatedDataTabCommonContent {...props} />
            </TabBody>
        </EventPanelTab>
    );
});
